import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'

import AnimatedBackground from '@components/AnimatedBackground'
import { shuffleAnimatedBackground } from '@components/AnimatedBackground/AnimatedBackground.utils'

/**
 * What every signed out route shares: the animated wash behind it. The column, the bar and
 * the `main` landmark come from each route's own `Screen`, as they do everywhere else.
 *
 * @param {object} props - The component props.
 * @returns {JSX.Element} The rendered wash and the routed screen.
 */
export default function AuthBase({ children }) {
  const location = useLocation()

  useEffect(() => {
    shuffleAnimatedBackground()
  }, [location.pathname])

  return (
    <>
      <AnimatedBackground />
      {children || <Outlet />}
    </>
  )
}
